import Vue from 'vue'
import Vuex from 'vuex'
import cognito from 'src/components/Cognito/state'
import VuexPersistence from 'vuex-persist'
import common from './common'

import baseStates from './baseStates'

import timesheet from '../components/Sheets/Timesheet/state'
import sheet from '../components/Sheets/Sheet/state'
import notification from '../components/MainHeader/state'
import dashboards from '../components/DashBoards/state'
import verifyTimesheet from '../components/Sheets/VerifyTimesheet/state'
import whb from '../components/Whb/state'
import workSchedule from 'src/components/WorkSchedule/state'
import employee from 'src/components/Employee/state'
import approvalsRules from 'src/components/ApprovalsRules/state'
import disciplineRules from 'src/components/DisciplineRules/state'
import company from 'src/components/Company/state'
import locker from 'src/components/Locker/state'
import timeoff from 'src/components/HourBankRules/state'
import faceBiometric from 'src/components/FaceBiometric/state'
import permissions from 'src/components/Permissions/state'
import activityManager from 'src/components/Activities/ActivityManagement/state'
import regrasDeNotificacao from 'src/typescript/components/RegrasDeNotificacao/state'

Vue.use(Vuex)

const persistor = new VuexPersistence({
  key: 'vuex',
  modules: ['auth', 'visualConfigs']
})

const MODULES_PER_NAME = {
  timesheet: timesheet
}

const store = new Vuex.Store({
  state: {
    auth: {
      authorization: null,
      accessToken: null,
      refreshToken: null, // it wil only exists if theres login with saml, amplify handles it in normal logins
      userPoolId: null,
      userPoolWebClientId: null,
      tokenAPI: null
    },
    backNotification: null,
    userInfo: null,
    visualConfigs: null
  },
  ...baseStates,
  modules: {
    cognito,
    common,
    timesheet,
    sheet,
    dashboards,
    notification,
    verifyTimesheet,
    whb,
    workSchedule,
    employee,
    approvalsRules,
    disciplineRules,
    company,
    locker,
    timeoff,
    faceBiometric,
    permissions,
    regrasDeNotificacao,
    activityManager
  },
  plugins: [
    persistor.plugin
  ]
})

export async function requestModuleUse (modulePath) {
  if (!store.state[modulePath]) {
    await store.registerModule(modulePath, MODULES_PER_NAME[modulePath])
  }
}

window.vuex = store

export default store
